export default __webpack_public_path__ + "static/media/pool.27c1787f.svg";